// removed by extract-text-webpack-plugin
module.exports = {"root":"refund--root--1WoxK2uK home--root--2rXwqQ3Z organization-home--root--29mpR9MJ","grid-container":"refund--grid-container--6xMaYOC3 home--grid-container--3c3JLjRI","gridContainer":"refund--grid-container--6xMaYOC3 home--grid-container--3c3JLjRI","form-container":"refund--form-container--kpzIXzUA home--message--9FSspPIv","formContainer":"refund--form-container--kpzIXzUA home--message--9FSspPIv","title":"refund--title---zlD2E9d crops--title--3nbOw3vq","subtitle":"refund--subtitle--3vEs199x","reminder":"refund--reminder--1WdINI2T"};


//////////////////
// WEBPACK FOOTER
// ./views/refunds/cl-multiplier/refund/styles.css
// module id = ./views/refunds/cl-multiplier/refund/styles.css
// module chunks = 0